import { BaseColorCode } from "../data/bruktbilsalgBackend/types/car.types";

export const translateBaseColorCode = (baseColorCode: BaseColorCode) => {
  switch (baseColorCode) {
    case "Beige":
      return "Beige";
    case "Blue":
      return "Blå";
    case "Bronze":
      return "Bronse";
    case "Brown":
      return "Brun";
    case "Green":
      return "Grønn";
    case "Grey":
      return "Grå";
    case "Gold":
      return "Gull";
    case "Yellow":
      return "Gul";
    case "White":
      return "Hvit";
    case "Violet":
      return "Fiolett";
    case "Orange":
      return "Oransje";
    case "Pink":
      return "Rosa";
    case "Red":
      return "Rød";
    case "Black":
      return "Svart";
    case "Silver":
      return "Sølv";
    case "Turquoise":
      return "Turkis";

    default:
      return "";
  }
};
